module.exports = __webpack_public_path__ + "img/0-interior-roof.7a0612e3.svg";